import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
import { Message } from "element-ui";

const socialhub = {
  state: () => ({
    items: [],
    filter: {
      skip: 0,
      take: 5,
      searchTerm: null,
      ids: [],
      sessionIds: [],
      subjectIds: [],
      type: null,
      status: null,
      socialHubPostSortingType: null,
      isDraft: false
    },
    draftInfiniteId: +new Date(),
    commentsFilter: {
      skip: 0,
      take: 1000000,
      searchTerm: null,
      ids: [],
      postId: null,
      parentId: null
    },
    likesFilter: {
      skip: 0,
      take: 6,
      searchTerm: null,
      ids: [],
      postId: null
    }
  }),
  mutations: {
    setDraftInfinite(state) {
      state.draftInfiniteId += 1;
    },
    clearPostList(state) {
      state.items = [];
    },

    setPostList(state, payload) {
      payload = payload.map(x => {
        return {
          ...x,
          postComments: []
        };
      });
      state.items.push(...payload);
    },
    setSocialHubList(state, payload) {
      state.items = payload;
    },
    setFilterDraft(state, payload) {
      state.filter.isDraft = payload;
    },
    deleteSocialPost(state, payload) {
      state.items = state.items.filter(x => x.id != payload);
    },
    editPost(state, payload) {
      var fIndex = state.items.findIndex(x => x.id == payload.id);
      state.items.splice(fIndex, 1, payload);
    }
  },
  actions: {
    async socialHubMentionSearch(store, payload) {
      var res = await axios.post("/SocialHub/SearchMention", { searchTerm: payload });
      return res;
    },
    async socialHubGet(store, payload) {
      var res = await axios.post("/SocialHub/Get", { id: payload });
      return res;
    },
    async socialHubList(store, payload) {
      var res = await axios.post("/SocialHub/List", payload);
      return res;
    },
    async toggleLikeComment(store, payload) {
      var res = await axios.post("/SocialHub/ToggleLikeComment", payload);
      return res;
    },
    async socialHubAddOrUpdate(store, payload) {
      var res = await axios.post("/SocialHub/AddOrUpdate", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        // Message.success(res.data.alert.message);
        var fIndex = store.state.items.findIndex(x => x.id == res.data.data.item.id);
        if (fIndex != -1) {
          store.state.items.splice(fIndex, 1, res.data.data.item);
        }
        store.commit("setDraftInfinite");
      }
      return res;
    },
    async socialHubDelete(store, payload) {
      // {
      //     "id": "string"
      // }
      var res = await axios.post("/SocialHub/Delete", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        store.commit("deleteSocialPost", payload.id);
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async socialHubToggleLike(store, payload) {
      // {
      //     "id": "string",
      //     "isLiked": true
      // }
      var res = await axios.post("/SocialHub/ToggleLike", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      }
      return res;
    },
    async socialHubToggleLikeComment(store, payload) {
      // {
      //     "id": "string",
      //     "isLiked": true
      // }
      var res = await axios.post("/SocialHub/ToggleLikeComment", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      }
      return res;
    },
    async socialHubChangeStatus(store, payload) {
      // {
      //     "id": "string",
      //     "status": "string"
      // }
      var res = await axios.post("/SocialHub/ChangeStatus", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async socialHubListLikes(store) {
      var res = await axios.post("/SocialHub/ListLikes", store.state.likesFilter);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(this.$t("components.socialhub.postCard.likeListUploadMsg"));
      }
    },
    async socialHubListComments(store, payload) {
      var res = await axios.post("/SocialHub/ListComments", payload);
      return res;
    },
    async socialHubClear(store, payload) {
      // payload = { type: [] }
      var res = await axios.post("/SocialHub/ClearSocialHub", { type: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async socialHubToggleIsOver(store, payload) {
      var res = await axios.post("socialhub/toggleisover", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },

    async socialHubAddUpdateComment(store, payload) {
      // {
      //     "id": "string",
      //     "postId": "string",
      //     "commentText": "string",
      //     "parentId": "string",
      //     "mentions": [
      //         {
      //         "id": "string",
      //         "type": "string",
      //         "title": "string",
      //         "image": "string",
      //         "fullName": "string",
      //         "participantId": "string"
      //         }
      //     ]
      // }
      var res = await axios.post("/SocialHub/addUpdateComment", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async socialHubDeleteComment(store, payload) {
      // {
      //     "id": "string"
      // }
      var res = await axios.post("/SocialHub/DeleteComment", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async socialHubToggleHasScreencast(store, payload) {
      // {
      //     "id": "string"
      // }
      var res = await axios.post("/SocialHub/ToggleHasScreencast", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    }
  },
  getters: {
    getDraftInfiniteId: state => state.draftInfiniteId,
    getSocialHubList: state => state.items
  }
};
export default socialhub;



// WEBPACK FOOTER //
// ./src/store/socialhub.js